import React from 'react';
import PropTypes from 'prop-types';

import BlockLoader from 'components/BlockLoader/BlockLoader';
import CalculatorFormError from './CalculatorFormError/CalculatorFormError';

export default function withData({loader}) {
    return function (WrappedComponent) {
        class WithData extends React.Component {
            static propTypes = {
                forwardedRef: PropTypes.any.isRequired,
                title: PropTypes.string,
            };

            state = {
                isLoaded: false,
                data: null,
                error: null,
            };

            componentDidMount() {
                this.fetchData();
            }

            fetchData = async () => {
                try {
                    this.setState({isLoaded: false});
                    const data = await loader(this.props);
                    this.setState({isLoaded: true, data, error: null});
                } catch (err) {
                    this.setState({isLoaded: true, error: err});
                }
            };

            render() {
                const {forwardedRef, title, ...restProps} = this.props;
                const {isLoaded, data, error} = this.state;

                if (!isLoaded) {
                    return <BlockLoader />;
                } else if (error) {
                    return <CalculatorFormError title={title} action={{handler: this.fetchData}} />;
                } else {
                    return (
                        <WrappedComponent
                            {...restProps}
                            ref={forwardedRef}
                            data={data}
                            title={title}
                        />
                    );
                }
            }
        }

        function forwardRef(props, ref) {
            return <WithData {...props} forwardedRef={ref} />;
        }
        forwardRef.displayName = `withData(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;

        return React.forwardRef(forwardRef);
    };
}
